module.exports = __webpack_public_path__ + "static/iso45001-de002fbc90f17c0a1aff343895c260d8.svg";